"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useServiceUrls = void 0;
var _react = require("react");
var _serviceUrlsContext = require("./serviceUrlsContext");
/**
 * Returns base URL of all available services provided by the @see {ServiceUrlsProvider} up the tree.
 * Services passed as an argument are validated and typed as required. An error is thrown in case any of them is not available.
 * Optional service URLs can be retrieved as well, those should not be specificed in the @see {requiredServices} array.
 * @param requiredServices These services are validated and typed as required.
 * @returns All available services with some of them typed as required.
 */
const useServiceUrls = requiredServices => {
  const allClientServices = (0, _react.useContext)(_serviceUrlsContext.serviceUrlsContext);
  const missingServices = requiredServices.filter(serviceName => !allClientServices[`${serviceName}Url`]);
  if (missingServices.length > 0) {
    throw new Error(`Following required client services '${missingServices.join(', ')}' were not found in ServiceUrlsProvider!`);
  }
  return allClientServices;
};
exports.useServiceUrls = useServiceUrls;
//# sourceMappingURL=useServiceUrls.js.map